import { moduleName } from '../constants';

export const ADD_CHILDREN = `${moduleName}/ADD_CHILDREN`;
export const addChildren = children => ({
  type: ADD_CHILDREN,
  payload: children,
});
